import { render, staticRenderFns } from "./SyllabusStructure.vue?vue&type=template&id=0fac2a24&"
import script from "./SyllabusStructure.vue?vue&type=script&lang=js&"
export * from "./SyllabusStructure.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusStructure.vue?vue&type=style&index=0&id=0fac2a24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports